import { useState, useEffect, ChangeEvent, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Checkbox,
  Space,
  Button,
  Spin,
  AutoComplete,
  Modal,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import {
  CreatedType,
  RegistrationCompanyResponseDto,
  RegistrationStatus,
} from "../../models/Registration";
import { RoleType } from "../../models/Role";
import { useApplicationContext } from "../../application/ApplicationContext";
import { activeUser } from "../../services/AuthServices";
import {
  createCompanyRegistration,
  deleteRegistration,
  getCompanyRegistration,
  updateCompanyRegistration,
  getAllCompanyInformation,
} from "../../services/RegistrationService";
import { getAllEvents } from "../../services/EventService";
import Home from "../../assets/home.png";
import Profile from "../../assets/profile.png";
import AddNewAccommodation from "../../components/AddNewAccommodation/AddNewAccommodation";
import NewParticipant from "../../components/NewParticipant/NewParticipant";
import "./NewRegistrationCompanyPage.scss";
import dayjs from "dayjs";
import { EventDto, EventListDto } from "../../models/Event";
import { Notification, NotificationType } from "../../models/Notification";
import {
  AccommodationDto,
  AdditionalPersonDto,
} from "../../models/Accommodation";
import { addThousandSeparator } from "../../core/Utility";
import { getAllNotifications } from "../../services/NotificationService";
import { getAllImportedParticipant } from "../../services/ImportedParticipantService";
import { Toast } from "primereact/toast";
import useFetchOneEvent from "../../customHooks/FetchOneEvent/FetchOneEvent";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";

const NewRegistrationCompanyPage = () => {
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const navigate = useNavigate();
  const { setBreadcrumb, setNotificationNumber } = useApplicationContext();
  const [form] = Form.useForm();
  let { id } = useParams<{ id: string }>();
  const Option = Select.Option;
  const [idEvent, setIdEvent] = useState<string | undefined>(undefined);
  const [oneEvent, setOneEvent] = useState<EventDto>();
  const [allEvents, setAllEvents] = useState<EventListDto[]>([]);
  const [allCompanies, setAllCompanies] = useState<any[]>([]);
  const [getNewPriceData, setGetNewPriceData] = useState<boolean>(false);
  const [companyOptions, setCompanyOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [allImportedParticipants, setAllImportedParticipants] = useState<any[]>(
    []
  );
  const [importedParticipantOptions, setImportedParticipantOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const [selectCompanyName, setSelectCompanyName] = useState("");
  const [data] = useFetchOneEvent(idEvent);

  const isAccommodationRequired = Form.useWatch(
    "isAccommodationRequired",
    form
  );
  const [totalPrice, setTotalPrice] = useState<any>(0);
  const registrationFee = oneEvent?.registrationFee ?? 0;
  const [refreshImportedParticipants, setRefreshImportedParticipants] =
    useState(false);
  const [status, setSTatus] = useState(undefined);
  const [textMessage, setTextMessage] = useState<any>(undefined);
  const toast = useRef<any>(null);
  const [invoice, setInvoice] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [oneRegistration, setOneRegistration] = useState<any>();

  const Country = [
    { label: "Srbija", value: "Srbija" },
    { label: "Inostranstvo", value: "Inostranstvo" },
  ];

  const insuranceCompany = [
    {
      label: "Da",
      value: true,
    },
    {
      label: "Ne",
      value: false,
    },
  ];

  useEffect(() => {
    setShowInfoModal(invoice);
  }, [invoice]);

  useEffect(() => {
    const values = form.getFieldValue("accommodations");
    if (values?.length === 0) {
      handleTotalPrice(0);
    }
  }, [getNewPriceData]);

  useEffect(() => {
    if (!isAccommodationRequired || isAccommodationRequired === undefined) {
      let total = 0;
      const fieldsFormData = form.getFieldValue("additionalPerson");
      fieldsFormData?.map((el: any) => {
        total = total + data?.registrationFee;

        // total =
        //   total +
        //   ((dinner && data?.dinnerFee) || 0) +
        //   ((registrationFee && data?.registrationFee) || 0);
      });
      handleTotalPrice(total);
      setGetNewPriceData(false);
    } else {
      const fieldsFormData = form.getFieldValue("accommodations");
      if (!fieldsFormData || fieldsFormData.length === 0) {
        handleTotalPrice(0);
      }
    }
  }, [isAccommodationRequired, getNewPriceData, registrationFee]);

  useEffect(() => {
    setOneEvent(data);
  }, [data]);

  useEffect(() => {
    setBreadcrumb(["Kreiranje prijave", "Prijava pravno lice"]);
    getAllEvents().then((eventResponse) => {
      let newEventOptions: EventListDto[] = [];
      eventResponse.data.result?.map((eventItem: EventDto) => {
        newEventOptions.push({
          label: eventItem.name,
          value: eventItem.name,
          id: eventItem.id,
        });
      });
      setAllEvents(newEventOptions);
    });
    getAllCompanyInformation().then((companyResponse) => {
      const allCompany = companyResponse.data.result;
      let allNewCompanyOptions: { label: string; value: string }[] = [];
      let allNewCompanies: any[] = [];
      allCompany.map((item: any) => {
        if (item.isInsuranceCompany === true) {
          allNewCompanies.push(item);
          allNewCompanyOptions.push({
            label: item.companyName,
            value: item.companyName,
          });
        }
      });
      setAllCompanies(allNewCompanies);
      setCompanyOptions(allNewCompanyOptions);
    });
  }, []);

  useEffect(() => {
    if (id) {
      setActiveSpinner(true);
      getCompanyRegistration(id)
        .then((response: RegistrationCompanyResponseDto) => {
          if (response.data.result?.invoice?.sentEmail) {
            setInvoice(false); ///// - ODBLOKIRAJ SLANJE PROFAKTURE
          } else {
            setInvoice(false);
          }
          let newObject = { ...response.data.result };
          newObject.event = newObject?.event?.id;
          setIdEvent(newObject?.event);
          if (newObject.isAccommodationRequired) {
            newObject.accommodations = newObject?.accommodations?.map(
              (el: AccommodationDto) => {
                return {
                  ...el,
                  date: [dayjs(el.date[0]), dayjs(dayjs(el.date[1]))],
                };
              }
            );
          }
          form.setFieldsValue(newObject);
          setOneRegistration(newObject);
        })
        .catch((err: Error) => console.log(err));
    } else {
      form.resetFields();
      setInvoice(false);
    }
  }, [id]);

  useEffect(() => {
    if (idEvent !== undefined) {
      getAllImportedParticipant().then((response) => {
        const data = response.data.result;
        let allOptions: { label: string; value: string }[] = [];
        let allImportedparticipants: any[] = [];
        data.filter((el: any) => {
          if (
            el.eventId === idEvent &&
            selectCompanyName == el.registrationCompany &&
            !el.usage
          ) {
            allImportedparticipants.push(el);
            allOptions.push({
              label: `${el.firstName} ${el.lastName}`,
              value: `${el.firstName} ${el.lastName}`,
            });
          }
        });

        setAllImportedParticipants(allImportedparticipants);
        setImportedParticipantOptions(allOptions);
        setRefreshImportedParticipants(false);
      });
    }
  }, [idEvent, refreshImportedParticipants, selectCompanyName]);

  useEffect(() => {
    if (!status) return;
    if (status !== 409) {
      setSTatus(undefined);
      return navigate("/registration-list", { replace: true });
    } else {
      toast?.current?.show({
        severity: "error",
        detail: `Već postoji uneti broj telefona ${textMessage}.`,
        life: 3000,
      });
      setSTatus(undefined);
    }
  }, [status]);

  const handleInfoModal = () => {
    setShowInfoModal(false);
  };

  const handleImportedParticipants = (refresh: boolean) => {
    setRefreshImportedParticipants(refresh);
  };

  const handleGetPriceData = (get: boolean) => {
    setGetNewPriceData(get);
  };

  const handleTotalPrice = (price: any) => {
    setTotalPrice(price);
  };

  const handleSpinner = (show: boolean) => {
    return setActiveSpinner(show);
  };

  const handleCheckboxGroup = (
    e: ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    if (name === "noAccommodation") {
      form.setFieldValue("isAccommodationRequired", false);
      // form.setFieldValue("accommodations", []);
    } else {
      form.setFieldValue("noAccommodation", false);
      // form.setFieldValue("additionalPerson", []);
    }
  };

  const handleEvent = (e: string) => {
    let values = form.getFieldValue("accommodations");
    if (values) {
      values = values.map((item: AccommodationDto, index: number) => {
        return (item = {
          ...item,
          accommodationId: undefined,
          roomType: undefined,
          date: undefined,
          parkingPlaces: undefined,
          note: undefined,
        });
      });

      form.setFieldValue("accommodations", values);
    }
    setIdEvent(e);
  };

  const handleDeleteId = (deleteId: string) => {
    if (id && deleteId) {
      deleteRegistration(deleteId)
        .then((response: any) => {})
        .catch((err: Error) => console.log(err));
    }
  };

  const handleConfirmSaveForm = () => {
    const fieldValuesAccommodations = form.getFieldValue("accommodations");
    const fieldValuesAdditionalPerson = form.getFieldValue("additionalPerson");

    let accommodationAdditionalPersonLength = 0;

    if (isAccommodationRequired) {
      fieldValuesAccommodations?.map((el: any) => {
        if (el.additionalPerson.length > 0) {
          return (accommodationAdditionalPersonLength =
            accommodationAdditionalPersonLength + el.additionalPerson.length);
        }
      });
    } else {
      accommodationAdditionalPersonLength =
        fieldValuesAdditionalPerson?.length ?? 0;
    }

    if (accommodationAdditionalPersonLength !== 0) {
      if (!id) {
        return handleSaveForm();
      } else {
        return handleEditForm();
      }
    } else {
      toast?.current?.show({
        severity: "error",
        detail: `Nije moguće kreirati prijavu bez učesnika!`,
        life: 3000,
      });
    }
  };

  const handleSaveForm = () => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setActiveSpinner(true);
        const data = form.getFieldsValue();

        data.createdType = CreatedType.Administration;

        data.user = { id: activeUser?.id };
        data.totalPrice = totalPrice;

        const singleEvent: any = allEvents.filter((el: EventListDto) => {
          if (el.id === data.event) {
            return { id: el.id, name: el.value };
          }
        });
        data.event = { id: singleEvent[0].id, name: singleEvent[0].value };

        delete data.noAccommodation;

        if (data.isAccommodationRequired !== true) {
          data?.additionalPerson?.map((el: AdditionalPersonDto, i: number) => {
            let copyOfNewEl = {
              ...el,
              status: RegistrationStatus.Pending,
              lastStatusChange: new Date(),
              user: { id: activeUser?.id },
            };
            data.additionalPerson[i] = { ...copyOfNewEl };
          });
        } else {
          data?.accommodations?.map((el1: AccommodationDto, i: number) => {
            el1.additionalPerson?.map((el: AdditionalPersonDto, j: number) => {
              let copyOfNewEl = {
                ...el,
                status: RegistrationStatus.Pending,
                lastStatusChange: new Date(),
                isAccommodationRequired: true,
                roomId: el1.roomId,
                eventXRoomType: { id: el1.roomType },
                accommodation: { id: el1.accommodationId },
                user: { id: activeUser?.id },
                uosPayment: el1.uosPayment,
                roomTypeId: el1.roomType,
                numberOfDays: el1.numberOfDays,
                priceOfAccommodation:
                  Number(el1.priceOfAccommodation) /
                  Number(el1.numberOfPersons),
                parkingPlace: el1.parkingPlaces,
                event: { id: singleEvent[0].id, name: singleEvent[0].value },
              };
              data.accommodations[i].additionalPerson[j] = { ...copyOfNewEl };
            });
          });
        }
        createCompanyRegistration({
          ...data,
          date: new Date(),
        })
          .then(() => {
            toast?.current?.show({
              severity: "success",
              detail: `Uspešno kreirana prijava`,
              life: 3000,
            });
            let copyOfNewNotifications: Notification[] = [];
            getAllNotifications().then((response) => {
              response.data.result.map((item: any) => {
                setSTatus(response.status);
                setTextMessage("");
                if (
                  activeUser?.role.name === RoleType.Agency &&
                  item.type === NotificationType.AGENCY
                ) {
                  copyOfNewNotifications.push(item);
                }
                if (
                  activeUser?.role.name === RoleType.Employee &&
                  item.type === NotificationType.EMPLOYEE
                ) {
                  copyOfNewNotifications.push(item);
                }
                if (activeUser?.role.name === RoleType.Admin) {
                  copyOfNewNotifications.push(item);
                }
              });
              const unseenNotifications = copyOfNewNotifications.filter(
                (oneNotification: Notification) =>
                  oneNotification.seen === false
              );
              setNotificationNumber(unseenNotifications.length);
            });
          })
          .catch((err: any) => {
            setActiveSpinner(false);
            let text = err.response.data.message.match(/\d/g);
            text = text.join("");
            setTextMessage(text);
            setSTatus(err.response.status);
          });
      },
      () => {
        console.log("");
      }
    );
  };

  const handleEditForm = () => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setActiveSpinner(true);
        const formFieldsContent = form.getFieldsValue();

        delete formFieldsContent["noAccommodation"];

        formFieldsContent.createdType = CreatedType.Administration;

        formFieldsContent.user = { id: activeUser?.id };

        formFieldsContent.totalPrice = totalPrice;

        const singleEvent: any = allEvents.filter((el: EventListDto) => {
          if (el.id === formFieldsContent.event) {
            return { id: el.id, name: el.value };
          }
        });

        formFieldsContent.event = {
          id: singleEvent[0].id,
          name: singleEvent[0].value,
        };

        if (formFieldsContent.isAccommodationRequired !== true) {
          formFieldsContent?.additionalPerson?.map(
            (el: AdditionalPersonDto, i: number) => {
              let copyOfNewEl = {
                ...el,
                status: el.status ? el.status : RegistrationStatus.Pending,
                lastStatusChange: new Date(),
                uosPayment: false,
                user: { id: activeUser?.id },
              };
              formFieldsContent.additionalPerson[i] = { ...copyOfNewEl };
            }
          );
        } else {
          formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              el1.additionalPerson?.map(
                (el: AdditionalPersonDto, j: number) => {
                  let copyOfNewEl = {
                    ...el,
                    status: el.status ? el.status : RegistrationStatus.Pending,
                    lastStatusChange: new Date(),
                    roomId: el1.roomId,
                    eventXRoomType: { id: el1.roomType },
                    accommodation: { id: el1.accommodationId },
                    user: { id: activeUser?.id },
                    uosPayment: el1.uosPayment,
                    roomTypeId: el1.roomType,
                    numberOfDays: el1.numberOfDays,
                    priceOfAccommodation:
                      Number(el1.priceOfAccommodation) /
                      Number(el1.numberOfPersons),
                    parkingPlace: el1.parkingPlaces,
                    event: {
                      id: singleEvent[0].id,
                      name: singleEvent[0].value,
                    },
                  };
                  formFieldsContent.accommodations[i].additionalPerson[j] = {
                    ...copyOfNewEl,
                  };
                }
              );
            }
          );
        }

        const completeRegistration = {
          ...formFieldsContent,
          date: new Date(),
          isCompanyRegistration: false,
          lastStatusChange: new Date(),
        };

        updateCompanyRegistration(id, completeRegistration)
          .then((response) => {
            setSTatus(response.status);
            setTextMessage("");
            toast?.current?.show({
              severity: "success",
              detail: `Uspešno ažurirani podaci o prijavi`,
              life: 3000,
            });
          })
          .catch((err: any) => {
            setActiveSpinner(false);
            let text = err.response.data.message.match(/\d/g);
            text = text.join("");
            setTextMessage(text);
            setSTatus(err.response.status);
          });
      },
      () => {
        console.log("");
      }
    );
  };

  const onCompanyNameSelect = (value: any) => {
    setSelectCompanyName(value);
    const selectedCompany = allCompanies.find(
      (item) => item.companyName === value
    );
    form.setFieldValue(
      "isInsuranceCompany",
      selectedCompany.isInsuranceCompany
    );
    form.setFieldValue("companyAddress", selectedCompany.companyAddress);
    form.setFieldValue("companyId", selectedCompany.companyId);
    form.setFieldValue("vatNumber", selectedCompany.vatNumber);
    form.setFieldValue("companyEmail", selectedCompany.companyEmail);
    form.setFieldValue(
      "companyPhone",
      selectedCompany.companyPhone.replace(/\s/g, "")
    );
    form.setFieldValue("companyStreet", selectedCompany.companyStreet);
    form.setFieldValue("companyCity", selectedCompany.companyCity);
    form.setFieldValue("companyCountry", selectedCompany.companyCountry);
    form.setFieldValue(
      "companyStreetNumber",
      selectedCompany.companyStreetNumber
    );
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <div
        className={
          !invoice
            ? "new-registration-company"
            : "new-registration-company disabled-registration-company"
        }
      >
        <Spin className="spinner" spinning={activeSpinner}>
          <Form
            form={form}
            name="new-legal-entity-form"
            layout="vertical"
            autoComplete="off"
          >
            <div className="header-box">
              <div className="wrapper">
                <img className="image" alt="" src={Home} />
                <p className="accordion-header" style={{ marginLeft: "10px" }}>
                  Poslovni podaci
                </p>
              </div>
            </div>
            <div className="inner-box">
              <Form.Item name="companyName" label="Naziv pravnog lica:">
                <AutoComplete
                  allowClear={true}
                  options={companyOptions}
                  className="input-label"
                  onSelect={(value) => onCompanyNameSelect(value)}
                  placeholder="Unesite naziv pravnog lica"
                  filterOption={(inputValue, option) =>
                    option!.value
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                />
              </Form.Item>
              <Form.Item
                name="isInsuranceCompany"
                label="Osiguravajuće društvo:"
              >
                <Select
                  placeholder="Da li je osiguravajuće društvo?"
                  options={insuranceCompany}
                />
              </Form.Item>
              <Form.Item
                name="event"
                label="Prijava za događaj:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti događaj!",
                  },
                ]}
              >
                <Select onChange={handleEvent} placeholder="Izaberite događaj">
                  {allEvents.map((el: any, i: number) => (
                    <Option key={el.id} value={el.id}>
                      {el.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"companyCountry"}
                label="Zemlja:"
              >
                <Select placeholder="Izaberite Zemlju" options={Country} />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"companyCity"}
                label="Grad:"
              >
                <Input className="input-label" placeholder="Unesite grad" />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"companyStreet"}
                label="Ulica:"
              >
                <Input className="input-label" placeholder="Unesite ulicu" />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"companyStreetNumber"}
                label="Broj:"
              >
                <Input className="input-label" placeholder="Unesite broj" />
              </Form.Item>
              <Form.Item
                name="vatNumber"
                label="PIB:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti PIB!",
                  },
                ]}
              >
                <Input
                  type="number"
                  className="input-label"
                  placeholder="Unesite PIB"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <Form.Item
                name="companyId"
                label="Matični broj:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti matični broj!",
                  },
                ]}
              >
                <Input
                  type="number"
                  className="input-label"
                  placeholder="Unesite matični broj"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti email adresu!",
                  },
                  {
                    validateTrigger: "submit",
                    type: "email",
                    message: "Unesite ispravan format e-maila!",
                  },
                ]}
                name="companyEmail"
                label="E-mail za dostavljanje predračuna:"
              >
                <Input
                  className="input-label"
                  placeholder="Unesite e-mail"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <Form.Item name="companyPhone" label="Kontakt telefon:">
                <Input
                  type="number"
                  className="input-label"
                  placeholder="Unesite kontakt telefon"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <div
                className={!id ? "checkbox-group" : "checkbox-group disabled"}
              >
                <Form.Item
                  name="isAccommodationRequired"
                  valuePropName="checked"
                >
                  <Checkbox
                    onChange={(e: any) =>
                      handleCheckboxGroup(e, "isAccommodationRequired")
                    }
                    className="checkbox"
                  >
                    <p className="checkbox-text">Potreban smeštaj</p>
                  </Checkbox>
                </Form.Item>
                <Form.Item name="noAccommodation" valuePropName="checked">
                  <Checkbox
                    onChange={(e: any) =>
                      handleCheckboxGroup(e, "noAccommodation")
                    }
                    className="checkbox"
                  >
                    <p className="checkbox-text">Bez smeštaja</p>
                  </Checkbox>
                </Form.Item>
              </div>
            </div>
            <div className="header-box">
              <div
                style={{ width: isAccommodationRequired ? "331px" : "228px" }}
                className="wrapper-second"
              >
                <img className="image" alt="" src={Profile} />
                <p className="accordion-header" style={{ marginLeft: "10px" }}>
                  {isAccommodationRequired
                    ? "Podaci o smeštaju i učesnicima"
                    : "Podaci o učesnicima"}
                </p>
              </div>
            </div>
            <div className="inner-box-second">
              {!isAccommodationRequired ? (
                <Form.List name="additionalPerson">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          className="list-of-data"
                          align="baseline"
                        >
                          <NewParticipant
                            form={form}
                            name={name}
                            restField={{ ...restField }}
                            remove={remove}
                            handleDeleteId={handleDeleteId}
                            paramsId={id}
                            handleSpinner={handleSpinner}
                            handleGetPriceData={handleGetPriceData}
                            handleTotalPrice={handleTotalPrice}
                            compoanyRegistration={true}
                            handleGetData={undefined}
                            allImportedParticipants={allImportedParticipants}
                            accommodationName={undefined}
                            importedParticipantOptions={
                              importedParticipantOptions
                            }
                            handleImportedParticipants={
                              handleImportedParticipants
                            }
                            individual={false}
                            isAccommodationRequired={isAccommodationRequired}
                            totalPrice={totalPrice}
                            event={data}
                          />
                        </Space>
                      ))}
                      <Form.Item
                        className={
                          idEvent === undefined ||
                          activeUser?.role.name === RoleType.Agency
                            ? "button-property-disabled"
                            : "button-property"
                        }
                      >
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          disabled={
                            idEvent === undefined ||
                            activeUser?.role.name === RoleType.Agency
                          }
                          block
                        >
                          Dodajte učesnika
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              ) : (
                <Form.List name="accommodations">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          className="list-of-data"
                          align="baseline"
                        >
                          <AddNewAccommodation
                            form={form}
                            needAccommodation={isAccommodationRequired}
                            name={name}
                            restField={{ ...restField }}
                            remove={remove}
                            idEvent={idEvent}
                            oneEvent={oneEvent}
                            paramsId={id}
                            individual={false}
                            handleTotalPrice={handleTotalPrice}
                            handleSpinner={handleSpinner}
                            getNewPriceData={getNewPriceData}
                            handleGetPriceData={handleGetPriceData}
                            registrationFee={registrationFee}
                            compoanyRegistration={true}
                            allImportedParticipants={allImportedParticipants}
                            importedParticipantOptions={
                              importedParticipantOptions
                            }
                            handleImportedParticipants={
                              handleImportedParticipants
                            }
                          />
                        </Space>
                      ))}
                      <Form.Item className="button-property">
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          disabled={activeUser?.role.name === RoleType.Agency}
                        >
                          Dodaj sobu
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              )}
            </div>
            <div className={"additional-fields"}>
              <div className="price-box">
                <p className="price-text">Ukupna cena učešća:</p>
                <span className="price-input">
                  {addThousandSeparator(totalPrice)}
                </span>
              </div>
              {!invoice && (
                <div>
                  {!id ? (
                    <Button
                      className="btn-save-form"
                      type="primary"
                      danger
                      htmlType="submit"
                      onClick={handleConfirmSaveForm}
                      disabled={activeUser?.role.name === RoleType.Agency}
                    >
                      Potvrdi
                    </Button>
                  ) : (
                    <Button
                      className="btn-save-form"
                      type="primary"
                      danger
                      htmlType="submit"
                      onClick={handleConfirmSaveForm}
                      disabled={activeUser?.role.name === RoleType.Agency}
                    >
                      Izmeni
                    </Button>
                  )}
                </div>
              )}
            </div>
          </Form>
        </Spin>
        <Modal
          maskClosable={false}
          open={showInfoModal}
          title={`Obavestenje`}
          onCancel={() => handleInfoModal()}
          onOk={() => handleInfoModal()}
          footer={[
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={"primary"}
              key={1}
              function={() => handleInfoModal()}
              text={"Zatvori"}
            />,
          ]}
        >
          <p className="notification-content">{`Profaktura je poslata mejlom. Nije moguće promeniti podatke kod profakture koja je poslata na mejl!`}</p>
        </Modal>
      </div>
    </PageLayout>
  );
};

export default NewRegistrationCompanyPage;
